import { useMutation } from '@tanstack/react-query'
import { deleteChat } from '@/api/workstation'
import { queryClient } from '@/main'

export function useDeleteChatMutation() {
  return useMutation({
    mutationFn: (chatId: string) => deleteChat(chatId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chat-history'] })
    },
  })
}
